import { render, staticRenderFns } from "./TheSecondaryToolbar.vue?vue&type=template&id=270f48e6&"
import script from "./TheSecondaryToolbar.vue?vue&type=script&lang=js&"
export * from "./TheSecondaryToolbar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "TheSecondaryToolbar.vue"
export default component.exports